import { render, staticRenderFns } from "./contactcontent.vue?vue&type=template&id=b114177e"
import script from "./contactcontent.vue?vue&type=script&lang=js"
export * from "./contactcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports